var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2941 14.5C14.2941 14.7812 14.0368 15 13.7794 15H10.6912C10.4017 15 10.1765 14.7812 10.1765 14.5V13H4V17.5C4 18.3125 4.70772 19 5.54412 19H18.9265C19.7307 19 20.4706 18.3125 20.4706 17.5V13H14.2941V14.5ZM18.9265 8H16.3529V6.5C16.3529 5.71875 15.6131 5 14.8088 5H9.66177C8.82537 5 8.11765 5.71875 8.11765 6.5V8H5.54412C4.70772 8 4 8.71875 4 9.5V12H20.4706V9.5C20.4706 8.71875 19.7307 8 18.9265 8ZM14.2941 8H10.1765V7H14.2941V8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.56ee67a9d4079c170d7312b2bf228c71.svg";
export { ForwardRef as ReactComponent };